import { TokenName } from '../../config'

export class User {

  name: string
  email: string
  isAdmin: boolean
  channels: string[]
  locations: string[]
  tax_rates: number[]
  purchasers: string[]
  customers: string[]
  batch_numbers: string[]
  shippers: string[]
  brands: string[]
  users: string[]
  categories: string[]
  todos: string[]

  constructor(data: any = {}) {
    this.name = data.name
    this.email = data.email
    this.channels = data.channels || []
    this.locations = data.locations || []
    this.tax_rates = data.tax_rates || []
    this.purchasers = data.purchasers || []
    this.customers = data.customers || []
    this.batch_numbers = data.batch_numbers || []
    this.shippers = data.shippers || []
    this.brands = data.brands || []
    this.users = data.users || []
    this.categories = data.categories || []
    this.todos = data.todos || []
    this.isAdmin = true
    if (data.token) { this.storeUserProfile(data); }
  }

  private storeUserProfile(result: any) {
    localStorage.setItem(TokenName, JSON.stringify({
      email: result.email,
      token: result.token,
      role: 'admin'
    }));
  }

  public removeToken() {
    localStorage.removeItem(TokenName)
  }

}



// WEBPACK FOOTER //
// ./src/app/models/user/user.ts